import User from '@/utils/models/User'
let roles = User.roles();
export default [
{
    //Router Administrator    
    path: '/',      
    component: ()=> import('@/app/components/admin/AppLayout.vue'),
    meta:{guest:false},
    children : [       
    {
        path: '',
        redirect: { name: 'survey' },
    },    
    {
        name: 'login',
        path: 'login',
        redirect: { name: 'signin' },
    },
    {
        name: 'deny',
        path: 'deny',
        redirect: { name: '403' },
    },
    {
        name : 'dashboard',
        path : 'dashboard',
        component: () => import('@/app/views/dashboard/index.vue'),
        default: true,
    },   
    {
        title: 'Daftar Survey',
        name : 'survey',
        path : 'survey',
        component: () => roles.includes('customer') ? import('@/app/views/survey/customer.vue') : import('@/app/views/survey/index.vue'),          
    },
    {
        title: 'Daftar Survey',
        name : 'survey/customer',
        path : 'survey/customer',
        component: () => import('@/app/views/survey/customer.vue'),          
    },
    {
        title: 'List Respon',
        name : 'survey/respon',
        path : 'survey/respon',
        component: () => import('@/app/views/survey/respon/index.vue'),          
    },
    {
        title: 'Form Responden',
        name : 'survey/respon/form',
        path : 'survey/respon/form',
        component: () => import('@/app/views/survey/respon/form.vue'),          
    },    
    {
        title: 'View Responden',
        name : 'survey/respon/view',
        path : 'survey/respon/view',
        component: () => import('@/app/views/survey/respon/view.vue'),          
    },
    {
        title: 'Report Surveyor',
        name : 'report/surveyor',
        path : 'report/surveyor',
        component: () => import('@/app/views/report/surveyor/index.vue'),          
    },
    {
        title: 'Responden',
        name : 'report/responden',
        path : 'report/responden',
        component: () => import('@/app/views/report/responden/index.vue'),          
    },
    {
        title: 'Form',
        name : 'master/nodes',
        path : 'master/nodes',        
        component: () => import('@/app/views/master/nodes/index.vue'),          
    },
    {
        name : 'master/nodes/form',
        path : 'master/nodes/form',        
        component: () => import('@/app/views/master/nodes/form.vue'),          
    },    
    {
        name : 'master/partai',
        path : 'master/partai',
        component: () => import('@/app/views/master/partai/index.vue'),          
    },
    {
        title: 'Form Partai',
        name : 'master/partai/form',
        path : 'master/partai/form',
        component: () => import('@/app/views/master/partai/form.vue'),          
    }, 
    {
        name : 'master/calon',
        path : 'master/calon',
        component: () => import('@/app/views/master/calon/index.vue'),          
    },
    {
        title: 'Form Calon',
        name : 'master/calon/form',
        path : 'master/calon/form',
        component: () => import('@/app/views/master/calon/form.vue'),          
    }, 
    {
        name : 'master/kompetisi',
        path : 'master/kompetisi',
        component: () => import('@/app/views/master/kompetisi/index.vue'),          
    },
    {
        title: 'Form Kompetisi',
        name : 'master/kompetisi/form',
        path : 'master/kompetisi/form',
        component: () => import('@/app/views/master/kompetisi/form.vue'),          
    },
    {
        name : 'master/quetionnaire',
        path : 'master/quetionnaire',
        component: () => import('@/app/views/master/quetionnaire/index.vue'),          
    },
    {
        title: 'Quetionnaire',
        name : 'master/quetionnaire/form',
        path : 'master/quetionnaire/form',
        component: () => import('@/app/views/master/quetionnaire/form.vue'),          
    },
    {
        name : 'master/tps',
        path : 'master/tps',
        component: () => import('@/app/views/master/tps/index.vue'),          
    },
    {
        title: 'Form TPS',
        name : 'master/tps/form',
        path : 'master/tps/form',
        component: () => import('@/app/views/master/tps/form.vue'),          
    },
    {
        name : 'master/dapil',
        path : 'master/dapil',
        component: () => import('@/app/views/master/dapil/index.vue'),          
    },
    {
        title: 'Form Dapil',
        name : 'master/dapil/form',
        path : 'master/dapil/form',
        component: () => import('@/app/views/master/dapil/form.vue'),          
    },
    {
        name : 'profile',
        path : 'profile',
        component: () => import('@/app/views/profile/index.vue'),          
    },
    {
        title: 'Update Profile',
        name : 'profile/form',
        path : 'profile/form',
        component: () => import('@/app/views/profile/form.vue'),          
    },  
    /*{
        name : 'pages/blank',
        path : 'pages/blank',
        component: () => import('@/app/views/pages/blank.vue'),          
    },
    {
        name : 'pages/helloworld',
        path : 'pages/helloworld',
        component: () => import('@/app/views/pages/helloworld.vue'),          
    },*/    
    {
        name : 'admin/users',
        path : 'admin',
        component: () => import('@/app/views/admin/users/index.vue'),          
    },
    {
        name : 'admin/users/form',
        path : 'admin/users/form',
        component: () => import('@/app/views/admin/users/form.vue'),          
    }, 
    {
        name : 'admin/rbac',
        path : 'admin/rbac',
        component: () => import('@/app/views/admin/rbac/index.vue'),          
    }, 
    /*{
        path: '*',
        redirect: { name: '404' },
    },*/       
]},
{
    // Router untuk Guest    
    path: '/guest/',
    component: ()=> import('@/app/components/auth/AuthLayout.vue'),    
    children: [     
    {
        name: '404',
        path: '404',
        meta: {guest:true},
        component: () => import('@/app/components/auth/page/404.vue'),
    },
    {
        name: '403',
        path: '403',
        meta: {guest:true},
        component: () => import('@/app/components/auth/page/403.vue'),
    },
    {
        name: 'signin',
        path: 'signin',
        meta: {guest:true},
        component: () => import('@/app/views/auth/login.vue'),
    },
    
    {
        name: 'signup',
        path: 'signup',
        meta: {guest:true},
        component: () => import('@/app/views/auth/signup.vue'),
    },
    /*{
        name: 'recover-password',
        path: 'recover-password',
        meta: {guest:true},
        component: () => import('@/app/components/auth/recover-password/RecoverPassword.vue'),
    },*/
    {
        title: 'Print Responden',
        name : 'survey/respon/print',
        path : 'survey/respon/print',
        meta: {guest:true},
        component: () => import('@/app/views/survey/respon/print.vue'),          
    },
    {
        path: '*',
        meta: {guest:true},
        redirect: { name: 'signin' },
    },
    
    /*{
        path: '*',
        redirect: { name: '404' },
    },*/  
]}];